<template>
  <div id="onboarding" class="h-100 position-absolute w-100">
    <b-container class="h-100">
      <b-row align-h="center" align-v="center" class="h-100">
        <b-col cols="12" md="6" lg="6" class="mb-5 text-center">
          <img :src="logo" height="35" class="mt-4" alt="Pettysave Logo" />
          <h4 class="text-primary mt-3">Welcome, {{ userObj.firstname }}</h4>
          <p class="text-muted">
            Complete the following steps to activate your account
          </p>

          <div class="wrapper dash-card py-4 px-3 bg-white">
            <!-- <button
              class="btn btn-white dash-card w-100 my-1 text-left"
              style="border-bottom: 2px solid #85c341"
              v-b-toggle.email-content
              :disabled="userObj.emailverified == true"
            >
              <i class="fas fa-bullseye"></i>
              Email Verification {{ userObj.emailverified ? "[DONE]" : "" }}
              <i
                v-if="userObj.emailverified"
                class="fa fa-check-circle float-right mt-1"
                aria-hidden="true"
              ></i>
              <i
                v-else
                class="fa fa-caret-down float-right mt-1"
                aria-hidden="true"
              ></i>
            </button>-->

            <div class="py-3 px-2">
              <h5 v-if="!emailResent">
                <div class="bg-light px-3 py-4 dash-card">
                  Check your inbox:
                  <b style="text-decoration:underline">{{ userObj.email }}</b>
                  for the verification link we sent.
                </div>
                <br />But if you can't find it, please click
                <span
                  style="text-decoration: underline;cursor:pointer"
                  @click="resendEmail()"
                  >resend</span
                >
                to receive another one.
                <br />
                <br />If you wish to change your email,
                <span
                  v-b-modal.change-email-modal
                  style="text-decoration:underline;cursor:pointer; color: green"
                  >click here</span
                >
              </h5>
              <h4 v-else>We have sent the verification link to your email!</h4>
            </div>
            <!-- <button
              class="btn btn-white dash-card w-100 my-1 text-left"
              style="border-bottom: 2px solid #85c341"
              v-b-toggle.phone-content
              :disabled="userObj.phonenumberverified == true"
            >
              <i class="fas fa-bullseye"></i>
              Phone Number Verification
              {{ userObj.phonenumberverified ? "[DONE]" : "" }}
              <i
                v-if="userObj.phonenumberverified"
                class="fa fa-check-circle float-right mt-1"
                aria-hidden="true"
              ></i>
              <i
                v-else
                class="fa fa-caret-down float-right mt-1"
                aria-hidden="true"
              ></i>
            </button>

            <b-collapse
              id="phone-content"
              :visible="!userObj.phonenumberverified"
              class="mt-2"
            >
              <div class="py-4 px-2">
                <h4 v-if="!sent">
                  To verify your phone number:
                  <b>{{ userObj.phonenumber }}</b
                  >, we will send an OTP code to your phone. Click the button
                  below
                  <br />
                </h4>
                <h4 v-else>
                  Check your phone number for the OTP:
                  <b>{{ userObj.phonenumber }}</b>
                </h4>
                <StatefulButton
                  v-if="!sent"
                  :error="sent"
                  :loading="submitting"
                  loadingText="Sending..."
                  text="Send Verification"
                  elementType="button"
                  @click="sendCode('sms')"
                  elementClass="mb-2"
                />
                <h5 v-if="!sent">
                  If you wish to change your phone number,
                  <span
                    v-b-modal.change-phonenumber-modal
                    style="text-decoration:underline;cursor:pointer"
                    >click here</span
                  >
                </h5>
                <b-collapse
                  id="phone-content-inner"
                  :visible="sent"
                  class="mt-2"
                >
                  <b-form @submit="submit" @input="formInput">
                    <b-form-group
                      :invalid-feedback="formErrors.code"
                      :state="fieldState.code"
                    >
                      <b-input
                        type="tel"
                        required
                        :disabled="error || submitting"
                        v-model="form.code"
                        :state="fieldState.code"
                        placeholder="Enter OTP"
                      ></b-input>
                    </b-form-group>
                    <StatefulButton
                      :error="error || error2 || submitting"
                      :loading="submitting2"
                      text="Verify Phone Number"
                      loadingText="Verifying..."
                      elementClass="w-md-100"
                    />
                  </b-form>
                </b-collapse>
              </div>
            </b-collapse>-->
          </div>
          <br />
          <b-button class="btn btn-primary" @click="logout">Logout</b-button>
        </b-col>
      </b-row>
    </b-container>
    <ChangeEmail :userObj="userObj" />
    <ChangePhoneNo :userObj="userObj" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import StatefulButton from "@/components/actions/StatefulButton.vue";
import ChangeEmail from "./components/ChangeEmail";
import ChangePhoneNo from "./components/ChangePhoneNo";
import { AuthService, UserService } from "@/services";
import {
  validateDigits,
  validateRequired,
  checkFormErrors
} from "@/utils/validators";

export default {
  name: "onboarding",
  data() {
    return {
      logo: require("@/assets/icons/logo-dark.svg"),
      form: {
        code: ""
      },
      formErrors: {},
      emailResent: false,
      submitting: false,
      submitting2: false,
      sent: false,
      error: false,
      error2: false
    };
  },
  components: {
    // StatefulButton,
    ChangeEmail,
    ChangePhoneNo
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async resendEmail() {
      // try {
      const { message } = await AuthService.resendEmailVerification();
      this.$store.dispatch("toast", {
        message
      });
      this.emailResent = true;
      // } catch (err) {
      // console.error(err);
      // }
    },
    async sendCode(channel) {
      this.submitting = true;
      try {
        const { message } = await AuthService.sendVerificationPhoneNo(channel);
        this.$store.dispatch("toast", {
          message
        });
        this.sent = true;
      } catch (err) {
        this.error = true;
      } finally {
        this.submitting = false;
      }
    },
    async submit(event) {
      event.preventDefault();
      this.submitting2 = true;
      try {
        this.validateForm();

        const { message } = await AuthService.verifyPhoneNo(this.form.code);
        this.userObj.phonenumberverified = 1;
        this.$store.dispatch("user/updateProfile", { phonenumberverified: 1 });
        this.$store.dispatch("toast", {
          message
        });
        if (this.userObj.emailverified == true)
          this.$router.replace({ name: "dashboard" });
      } catch (err) {
        this.error2 = true;
        this.formErrors = err;
      } finally {
        this.submitting2 = false;
      }
    },
    validateForm() {
      let { errors, valid } = validateRequired(this.form);
      const { code } = this.form;
      if (!errors.code) {
        const res = validateDigits(code, "code");
        valid = valid && res.valid;
        errors.code = res.errors.code;
      }
      if (!errors.code && code.length != 6) {
        errors.code = "Verification code must contain 6 digits";
        valid = false;
      }

      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error2 = false;
      this.formErrors = {};
    }
  },
  created() {
    const data = this.$route.meta.__data;
    this.$store.dispatch("user/updateProfile", data);
  },
  async beforeRouteEnter(to, from, next) {
    const { profile: user } = await UserService.getProfile();
    to.meta.__data = user;
    const completeProfile = user.emailverified && user.phonenumberverified;
    if (completeProfile) {
      next("/dashboard");
    } else {
      next();
    }
  },
  mounted() {
    // const self = this;
    // setTimeout(() => {
    //   self.$drift.show();
    // }, 3000);
  }
};
</script>

<style lang="scss" scoped>
h4 {
  color: grey;
}
.step-number {
  position: absolute;
  top: 0;
  right: 10%;

  p {
    font-size: 100px;
    font-weight: 900;
    color: rgba(#000000, 0.1);
  }
}
</style>
